import { defineMessages } from 'react-intl';

const pointsMessages = defineMessages({
    points: {
        id: 'points',
        defaultMessage: 'Points',
    },
    point: {
        id: 'point',
        defaultMessage: 'Point',
    },
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    cameraNumber: {
        id: 'camera-number',
        defaultMessage: 'Camera number',
    },
    pricePlan: {
        id: 'pricing-plan',
        defaultMessage: 'Pricing Plan',
    },
    entry: {
        id: 'entry',
        defaultMessage: 'Entry',
    },
    exit: {
        id: 'exit',
        defaultMessage: 'Exit',
    },
    allowNormalCards: {
        id: 'allow-normal-cards',
        defaultMessage: 'Allow normal cards',
    },
    updateSuccess: {
        id: 'edit-point-success',
        defaultMessage: 'The point was updated',
    },
    updateSuccessDescription: {
        id: 'edit-point-description-success',
        defaultMessage: 'The parking point was successfully updated.',
    },
});

export default pointsMessages;
